<template>
  <div>
    <appDrawer :drawer.sync="drawerShowed" @close="drawerShowed = false">
      <appDrawerMenu :menu="menu" :phone-block="headerAttrs.phoneBlock" @click="drawerShowed = false" />
    </appDrawer>
    <headerComponent
      :hide="!!$route.query.iframe"
      :drawer.sync="drawerShowed"
      :phoneBlock="phoneBlock"
      :langs="langs"
      :menu="menu"
      :logo="logo"
      :containered="true"
      showPartner
    />
    <main
      class="wet-app-main"
    >
      <transition name="page" mode="out-in">
        <router-view/>
      </transition>
      <footerComponent
        v-if="!$route.query.iframe"
        @partnermodal="modals.partner.showed = true"
        :data="footer"
        :menu="menu"
      />
    </main>
    <!-- modals section -->
    <modalComponent
      :showed.sync="modals.partner.showed"
      :modtitle="modals.partner.title"
      id="myModal"
    >
      <formComponent />
    </modalComponent>
    <transition name="fade-modal">
      <wetModal
        v-for="(item, i) in $store.state.modals" :key="i"
        :id="item.id"
        :icon="item.icon || 'info'"
        :opened="true"
        @close="() => {
          $store.commit('DEL_MODAL', item);
          if (typeof item.close === 'function') item.close();
        }"
        :title="item.title"
        :content="item.content"
        :actions="item.actions"
      ></wetModal>
    </transition>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import headerComponent from '@/components/header/headerIndex.vue';
import footerComponent from '@/components/footer/indexFooter.vue';
import appDrawer from '@/components/appDrawer.vue';
import appDrawerMenu from '@/components/drawers/appDrawerMenu.vue';
import formComponent from '@/components/formComponent.vue';
import modalComponent from '@/components/modalComponent.vue';
import common from '@/mixins/common';
import LogService from '@/services/LogService';
import configEnv from "@/enums/configEnv";

export default {
  mixins: [common],
  components: {
    headerComponent,
    footerComponent,
    appDrawer,
    appDrawerMenu,
    formComponent,
    modalComponent,
  },
  data() {
    return {
      drawerShowed: false,
      modals: {
        partner: {
          showed: false,
          title: 'Become a partner',
        },
      },
    };
  },
  computed: {
    ...mapState(['menu', 'langs', 'lang', 'logo', 'wpBaseUrl', 'strings']),
    ...mapGetters(['bgNoScroll']),
    headerAttrs() {
      let iconUrl = '';
      LogService.log('iconUrl string', this.strings.commonApp?.phone_icon?.url, this.strings);
      if (this.strings.commonApp?.phone_icon?.url) {
        iconUrl = `${configEnv.wpApiServer}/${this.strings.commonApp.phone_icon.url}`;
      }
      LogService.log('iconUrl headersAttr', iconUrl);
      const phoneBlock = {
        icon: iconUrl,
        phone: this.strings.commonApp?.phone_number ?? '',
        time: this.strings.commonApp?.working_time ?? '',
        phone_link: this.strings.commonApp?.phone_link ?? '',
        time_link: this.strings.commonApp?.working_time_link ?? ''
      };
      LogService.log('phoneBlock LandingLayout', phoneBlock);
      return {
        drawer: this.drawer,
        phoneBlock,
        langs: this.langs,
        menu: this.menu,
        logo: this.logo,
      };
    },
    footer() {
      return {
        imprint_text: this.strings.sections?.imprint_text,
        copyright_text: this.strings.sections?.copyright_text,
        become_a_partner_text: this.strings.sections?.become_a_partner_text,
        contract_withdrawal_text: this.strings.sections?.contract_withdrawal,
      };
    },
    phoneBlock() {
      let iconUrl = '';
      if (this.strings.sections?.phone_icon) {
        iconUrl = `${configEnv.wpApiServer}/${this.strings.sections.phone_icon}`;
      }
      return {
        icon: iconUrl,
        phone: this.strings.sections?.phone_number,
        time: this.strings.sections?.working_time,
      };
    },
    copyright_text() {
      return this.strings.sections?.copyright_text;
    },
    language_choose_text() {
      return this.strings.sections?.language_choose_text;
    },
  },
  created() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  watch: {
    bgNoScroll: {
      immediate: true,
      handler(bgNoScroll) {
        document.querySelector('body').classList.toggle('overflow-hidden', bgNoScroll);
      },
    },
  },
  destroyed() {
    document.querySelector('body').classList.toggle('overflow-hidden', false);
  },
};
</script>
